import { CSSTransition } from "react-transition-group";
import StepItem from "./StepItem";
import styles from "./Step.module.css";

export interface IStep {
  children: JSX.Element;
  stepBody?: JSX.Element;
  stepNumber: number;
  name: string;
  cssClasses: string;
  overlay: boolean;
}

const Step = ({ children, stepBody, stepNumber, name, cssClasses, overlay }: IStep) => {
  return (
    <div className={`${styles.step} ${cssClasses}`}>
      <StepItem item={{ id: stepNumber, label: name }} toggle={false}>
        {children}
      </StepItem>
      {stepBody}
      <hr />
      <CSSTransition in={overlay} timeout={150} classNames="overlay" unmountOnExit>
        <div className={styles.overlay} />
      </CSSTransition>
    </div>
  );
};

export default Step;
